export default __webpack_public_path__ + "a0324b2859b0ec0b845d18c677c1f650.webp";